import { render, staticRenderFns } from "./AwardType.vue?vue&type=template&id=19c15e1a"
import script from "./AwardType.vue?vue&type=script&lang=js"
export * from "./AwardType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports